// Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from '../state/documents/filter/actions';
import { getGroups } from '../state/domains/groups/actions';
import { getKeywords } from '../state/domains/keywords/actions';
import { getShapes } from '../state/domains/shapes/actions';
import { getFolders } from '../state/domains/folders/actions';

// Components
import SearchBar from '../components/Documents/SearchBar';

function mapStateToProps(state) {
	return {
		filter: state.documents.filter,
		groups: state.domains.groups,
		keywords: state.domains.keywords,
		shapes: state.domains.shapes,
		folders: state.domains.folders
		
	};
}

function mapDispatchToProps(dispatch) {

	return { 
		actions: bindActionCreators(actions, dispatch),
		getGroups: bindActionCreators(getGroups, dispatch),
		getFolders: bindActionCreators(getFolders, dispatch),
		getKeywords: bindActionCreators(getKeywords, dispatch),
		getShapes: bindActionCreators(getShapes, dispatch)
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(SearchBar);



// WEBPACK FOOTER //
// ./src/containers/SearchBarContainer.js